<template>
  <v-dialog
    :model-value="modelValue"
    width="1100"
    @update:model-value="onDialogVisibility"
    @click:outside="closeModal"
  >
    <v-card rounded="lg">
      <div class="bg-red-600 relative py-5">
        <i
          class="mdi mdi-close text-xl cursor-pointer text-white absolute top-2 right-3"
          @click="closeModal"
        ></i>
        <h2 class="text-xl font-semibold text-white pl-10">
          History Amandemen IMKP
        </h2>
        <p class="text-white text-xs pl-10">
          Daftar history amandemen IMKP yang dibuat kontraktor
        </p>
      </div>

      <div class="px-10 py-5">
        <div class="grid grid-cols-3 gap-2 items-end mb-4">
          <FormDate
            v-model="paramsHistory.keyword"
            label="Selesai Pekerjaan"
            placeholder="Pilih tanggal"
            clearable
            class="col-span-2"
          />
          <FormButton
            label="Cari Data"
            classes="bg-red-600 text-white w-full capitalize mb-0.5"
            @click="searchHistory"
          />
        </div>

        <div class="rounded-lg shadow-md overflow-x-auto">
          <v-data-table-server
            border="0"
            v-model:items-per-page="dataTable.pagination.itemsPerPage"
            :items-per-page-options="[5, 10, 25, 50, 100]"
            :headers="dataTable.headers"
            :items="dataTable.items"
            :loading="dataTable.loading"
            :items-length="dataTable.pagination.totalItems"
            @update:options="getHistory"
          >
            <template v-slot:item="{ item, index }">
              <tr
                class="border-gray-950"
                :class="{ 'bg-gray-50': index % 2 !== 0 }"
              >
                <td>{{ getIndex(index) }}</td>
                <td>{{ item.judulProyek }}</td>
                <td>
                  {{
                    moment(new Date(item.tanggalSelesaiPekerjaan)).format(
                      "DD MMMM YYYY",
                    )
                  }}
                </td>
                <td>
                  {{
                    moment(new Date(item.tanggalSelesaiPekerjaanNew)).format(
                      "DD MMMM YYYY",
                    )
                  }}
                </td>
                <td>
                  <p style="white-space: pre-line">
                    {{ item.alasanAmandemen }}
                  </p>
                </td>
                <td>
                  <span
                    class="badge"
                    :class="{
                      'text-bg-success': item.statusAmandemen === 'approved',
                      'text-bg-danger': item.statusAmandemen === 'rejected',
                    }"
                  >
                    {{
                      item.statusAmandemen === "approved"
                        ? "Diterima"
                        : item.statusAmandemen === "rejected"
                        ? "Ditolak"
                        : ""
                    }}
                  </span>
                  <p style="white-space: pre-line">
                    {{ item.catatanAmandemen }}
                  </p>
                </td>
                <td>
                  <ul
                    v-for="(file, i) in item.fileAmandemen"
                    :key="i"
                    class="p-0"
                  >
                    <li
                      @click="downloadFile(file)"
                      class="cursor-pointer link-danger link-offset-2 link-underline-opacity-0 link-underline-opacity-100-hover"
                    >
                      {{ `File_${i + 1}.pdf` }}
                    </li>
                  </ul>
                </td>
              </tr>
            </template>
            <template #no-data>
              <div class="py-6 text-center text-gray-500">
                Tidak ada history amandemen
              </div>
            </template>
          </v-data-table-server>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
import GlobalDataMixin from "@/GlobalDataMixin";
import FormDate from "@/components/FormDate.vue";
import FormButton from "@/components/FormButton.vue";
import axios from "axios";
import moment from "moment";
import { API_BASE_URL, CMS_GET_IMKP_HISTORY } from "@/constants";
import { downloadFile } from "@/utilities/globalFunction";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";
import util from "@/assets/js/util";

moment.locale("id");

const url_imkp_amandemen_history = API_BASE_URL + CMS_GET_IMKP_HISTORY;

const HISTORY_TABLE_HEADERS = [
  { title: "No.", key: "index", sortable: false, width: "5%" },
  { title: "Judul Proyek", key: "judulProyek", sortable: false, width: "20%" },
  { title: "Selesai Pekerjaan", key: "tanggalSelesai", sortable: false },
  {
    title: "Selesai Pekerjaan Amandemen",
    key: "tanggalSelesaiNew",
    sortable: false,
  },
  { title: "Alasan Amandemen", key: "alasanAmandemen", sortable: false },
  { title: "Status", key: "statusAmandemen", sortable: false },
  { title: "File", key: "fileAmandemen", sortable: false },
];

export default {
  name: "HistoryAmandemenImkpModal",
  mixins: [GlobalDataMixin],
  components: {
    FormDate,
    FormButton,
  },
  emits: ["update:modelValue"],
  props: {
    modelValue: { type: Boolean, default: false },
    imkpId: { type: [Number, String], default: null },
    usecase: { type: String, default: "kontraktor" },
  },
  data() {
    return {
      dataTable: CreateDataTableObject(HISTORY_TABLE_HEADERS),
      paramsHistory: {
        page: 0,
        perPage: 5,
        keyword: null,
      },
    };
  },
  computed: {
    /** Halaman kontraktor pakai role user; halaman approval (internal) pakai "isafe". */
    requestRole() {
      return this.usecase === "kontraktor" ? this.userData.role : "isafe";
    },
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.resetForm();
        this.getHistory();
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    moment,
    downloadFile,
    resetForm() {
      this.dataTable = CreateDataTableObject(HISTORY_TABLE_HEADERS);
      this.paramsHistory = { page: 0, perPage: 5, keyword: null };
    },
    searchHistory() {
      this.paramsHistory.page = 0;
      this.getHistory();
    },
    async getHistory({ page, itemsPerPage } = {}) {
      if (!this.imkpId) return;
      try {
        if (page) {
          this.paramsHistory.page = page - 1;
        }
        if (itemsPerPage) {
          this.paramsHistory.perPage = itemsPerPage;
        }

        this.dataTable.loading = true;

        const params = {
          usecase: this.usecase,
          idImkp: this.imkpId,
          search: this.paramsHistory.keyword
            ? moment(new Date(this.paramsHistory.keyword)).format("YYYY-MM-DD")
            : null,
          page: this.paramsHistory.page,
          perPage: this.paramsHistory.perPage,
        };

        const result = await axios.get(url_imkp_amandemen_history, {
          params,
          headers: {
            role: this.requestRole,
            Authorization: "Bearer " + this.userData.token,
            accept: "*/*",
          },
        });

        this.paramsHistory.page = result.data.page ?? 0;
        this.paramsHistory.perPage = result.data.perPage ?? 5;

        const data = (result.data.data || []).map((item) => {
          item.fileAmandemen = item.fileAmandemen
            ? JSON.parse(item.fileAmandemen)
            : [];
          return item;
        });

        this.dataTable = SetDataTableResponse(this.dataTable, {
          data,
          total_data: result.data.totalRow ?? 0,
          total_per_page: this.paramsHistory.perPage,
          current_page: this.paramsHistory.page,
        });
      } catch (error) {
        console.log("ERR getHistory : ", error);
        util.showError("Terjadi kesalahan saat mengambil history amandemen.");
      } finally {
        this.dataTable.loading = false;
      }
    },
    getIndex(index) {
      return (
        index +
        this.paramsHistory.page * this.dataTable.pagination.itemsPerPage +
        1
      );
    },
    closeModal() {
      this.onDialogVisibility(false);
    },
    onDialogVisibility(open) {
      this.$emit("update:modelValue", open);
    },
  },
};
</script>

<style scoped>
:deep(thead) {
  background-color: #fecaca;
}
:deep(.v-data-table tbody tr td) {
  border-bottom: none !important;
}
</style>
